import { MatDialogRef } from '@angular/material';
import { Component, Output, EventEmitter } from '@angular/core';
import { MotivosRechazo } from '../../cliente/motivosRechazo/motivosRechazo.model';
import { SnackService } from '../../shared-services/snack.service';

@Component({
    selector: 'app-modal-checklist-dialog',
    styleUrls: ['./modal-checklist-dialog.component.scss'],
    templateUrl: './modal-checklist-dialog.component.html',
})
export class ModalChecklistDialogComponent {

    public title: string;
    public firstMessage: string;
    public checklist: MotivosRechazo[];
    public seleccionados: Number[];
    public motivosSeleccionados: MotivosRechazo[];
    public observacion: string;

    okButtonTextLabel = 'Aceptar';
    cancelButtonTextLabel = 'Cancelar';

    constructor(public dialogRef: MatDialogRef<ModalChecklistDialogComponent>, private snackService: SnackService) {
      this.seleccionados = [];
      this.motivosSeleccionados = [];
      this.observacion = '';
    }

    public set okButtonText(value: string)  {
      this.okButtonTextLabel = value;
    }

    public set cancelButtonText(value: string) {
      this.cancelButtonTextLabel = value;
    }

    public aceptarDialogo() {
      if (this.seleccionados.length === 0){
      this.snackService.error('Debe seleccionar al menos un motivo de rechazo.');
      }else {
        this.dialogRef.close([this.seleccionados, this.observacion, this.motivosSeleccionados]);
      }
    }

    onCheckboxChange(accessory: any) {
      if (accessory.selected === true) {
          this.motivosSeleccionados.push(accessory);
          this.seleccionados.push(accessory.id);
      } else {
          const i = this.seleccionados.indexOf(accessory.id);
          if (i !== -1) {
              this.motivosSeleccionados.splice(i, 1);
              this.seleccionados.splice(i, 1);
          }
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/modals/modal-checklist-dialog.component.ts